import React, { useState, useEffect } from "react";
import {
  Button,
  Menu,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  TextField,
} from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { makeStyles } from "@material-ui/core/styles";
import http from "../../services/reportsPath";
import toast from "react-hot-toast";

const useStyles = makeStyles({
  root: {
    width: "100%",
  },
  table: {
    field: "Resizing",
    title: "Column Width",
    cellStyle: {
      whiteSpace: "nowrap",
      width: "20%",
    },
  },
  tableRow: {
    "&:hover": {
      cursor: "pointer",
    },
  },
  indeterminateColor: {
    color: "#f50057",
  },
  selectAllText: {
    fontWeight: 500,
  },
  selectedAll: {
    backgroundColor: "rgba(0, 0, 0, 0.08)",
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.08)",
    },
  },
  radio: {
    "&$checked": {
      color: "#57bf74",
    },
  },
  checked: {},
});

const TableAddReviewReq = ({ tableRows, reqTableRow, settabledata }) => {
  const classes = useStyles();

  const [editModal, setEditModal] = useState(false);
  const [deleteDialogBox, setdeleteDialogBox] = useState(false);
  const [dialogBoxfields, setdialogBoxfields] = useState({
    quantity: "",
    avgshareprice: "",
    requestID: "",
  });

  const [columns, setcolumns] = useState([
    {
      headername: "Stock Name",
      id: "Company Name",
    },
    {
      headername: "Asset Type",
      id: "Asset Class",
      preview: true,
    },
    {
      headername: "ISIN Code",
      id: "ISIN",
      preview: true,
    },
    {
      headername: "Quantity",
      id: "Quantity",
      //   format: "amount",
      preview: true,
    },
    {
      headername: "Average Share Price",
      id: "Average Share Price",
      preview: true,
    },
    {
      headername: "Invested Amount",
      id: "Invested Amount",
    },
    {
      headername: "Current Value",
      id: "Current Value",
      //   format: "date",
    },
    {
      headername: "Recommendation",
      id: "Recommendation",
      //   format: "date",
    },
    { id: "edit", headerName: "" },
    { id: "del", headerName: "" },
  ]);

  // Edit Quantity and Average Share Price
  const editRow = (object, action) => {
    // console.log(object);
    //  setEditCountryAmount(true);
    //  setEditingAmount(object.id);
    //  setIsinNumbers(object);
    if (action === "edit") {
      setEditModal(true);
    } else if (action === "delete") {
      setdeleteDialogBox(true);
    }

    //  setEditAmount(object);

    // Add Quantity and Avg Share Price to the Dialog fields
    // Replace null values with 0
    const newQuantity = object.Quantity === null ? 0 : object.Quantity;
    const newAvgSharePrice =
      object["Average Share Price"] === null
        ? 0
        : object["Average Share Price"];

    // Update the dialogBoxfields state with the new values
    setdialogBoxfields({
      quantity: newQuantity,
      avgshareprice: newAvgSharePrice,
      requestID: object.request_id,
    });
  };

  const handleEditDialogBoxFields = (event, fieldName) => {
    // const newValue = parseFloat(event.target.value);
    const newValue = event.target.value;
    setdialogBoxfields((prevState) => ({
      ...prevState,
      [fieldName]: newValue,
    }));
  };

  //Update Button
  const editRequest = () => {
    //   if (parseInt(editAmount) >= parseInt(data["totaladvisedamnt"])) {
    //     toast(
    //       "Amount should not be greater or equal than total advised amount"
    //     );
    //   } else if (parseInt(editAmount) < parseInt(data["totaladvisedamnt"])) {

    // console.log(dialogBoxfields, "dialogBoxfields");
    // console.log(dialogBoxfields.requestID, "dialogBoxfields");

    if (
      dialogBoxfields &&
      dialogBoxfields.quantity > 0 &&
      dialogBoxfields.avgshareprice > 0
    ) {
      http
        .get(
          "edit_review_request" +
            "?req_id=" +
            dialogBoxfields.requestID +
            "&" +
            "quantity=" +
            dialogBoxfields.quantity +
            "&" +
            "average_share_price=" +
            dialogBoxfields.avgshareprice
        )
        .then((res) => {
          if (res.data.statusCode === 0) {
            toast.success("Updated SuccessFully");
            setEditModal(false);
            reqTableRow(res.data.Data.advise_id);

            // update to initial state
            setdialogBoxfields({
              quantity: "",
              avgshareprice: "",
              requestID: "",
            });
          } else if (res.data.statusCode === 1) {
            toast.error("An error occured");
          }
        })
        .catch((error) => {
          console.log("Error found");
        });
    } else {
      toast.error("Quantity and Average Share Price are required fields");
    }
  };

  const deleteRequest = () => {
    console.log(dialogBoxfields, "dialogBoxfields");

    http
      .get("delete_request" + "?req_id=" + dialogBoxfields.requestID)
      .then((res) => {
        if (res.data.statusCode === 0) {
          toast.success("Deleted Successfully");
          setdeleteDialogBox(false);
          if (tableRows.length > 0) {
            const rowsAfterdelete = tableRows.filter(
              (row) => row.request_id !== dialogBoxfields.requestID
            );
            settabledata(rowsAfterdelete);
            //Assign the rows back to the array mapped in our table
            console.log(tableRows, "after delete");
          }

          // update to initial state
          setdialogBoxfields({
            quantity: "",
            avgshareprice: "",
            requestID: "",
          });
        } else if (res.data.statusCode === 1) {
          toast.error("An error occured");
        }
      })
      .catch((error) => {
        console.log("Error found");
      });
  };

  return (
    <>
      {columns.length ? (
        <TableContainer
          className={classes.container}
          style={{ marginBottom: "15px" }}
        >
          <Table>
            <TableHead>
              <TableRow>
                {columns.map((column, index) => {
                  return (
                    <TableCell>
                      <TableSortLabel>{column.headername}</TableSortLabel>
                    </TableCell>
                  );
                })}
              </TableRow>
            </TableHead>

            <TableBody>
              {tableRows.map((item, index) => {
                return (
                  <TableRow>
                    {columns.map((column, index) => {
                      const value = item[column.id];

                      return (
                        <TableCell>
                          {column.id === "edit" ? (
                            <Button
                              style={{
                                borderRadius: 10,
                                marginLeft: 10,
                                textTransform: "math-auto",
                              }}
                              onClick={() => editRow(item, "edit")}
                              variant="contained"
                              color="primary"
                            >
                              Edit
                            </Button>
                          ) : column.id === "del" ? (
                            <Button
                              onClick={() => editRow(item, "delete")}
                              variant="contained"
                              color="primary"
                            >
                              Delete
                            </Button>
                          ) : column.id === "Recommendation" ? (
                            value === "H" ? (
                              "Hold"
                            ) : value === "P" ? (
                              "Partial Sell"
                            ) : value === "S" ? (
                              "Sell"
                            ) : (
                              value
                            )
                          ) : value === null ? (
                            "N/A"
                          ) : (
                            value
                          )}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        ""
      )}

      {/* Edit Dialog */}
      <Dialog
        open={editModal}
        onClose={() => setEditModal(false)}
        //   PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
          Do you want to edit the below fields?
        </DialogTitle>
        <DialogContent>
          <TextField
            variant="outlined"
            size="small"
            value={dialogBoxfields.quantity}
            // disabled
            label="Quantity"
            InputLabelProps={{ shrink: true }}
            onChange={(event) => handleEditDialogBoxFields(event, "quantity")}
          />

          <TextField
            size="small"
            variant="outlined"
            value={dialogBoxfields.avgshareprice}
            label="Avg. Purchased Share Price"
            onChange={(event) =>
              handleEditDialogBoxFields(event, "avgshareprice")
            }
            // onChange={(e) => editAmountValidations(e)}
            style={{
              marginLeft: "25px",
              width: "300px",
            }}
            InputLabelProps={{ shrink: true }}
            // onChange={(e) => setEditAmount(e.target.value)}
          />
          {/* {
                        err ?<p style={{ color: 'red' }}>
                            Please enter valid amount                            
                        </p> : ""       
                    } */}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setEditModal(false)} variant="outlined">
            Cancel
          </Button>
          <Button
            autoFocus
            onClick={(e) => editRequest(e)}
            variant="contained"
            color="primary"
            // disabled={disableeditAmountUpdateBtn}
          >
            Update
          </Button>
        </DialogActions>
      </Dialog>

      {/* Delete Dialog */}

      <Dialog
        open={deleteDialogBox}
        onClose={() => setdeleteDialogBox(false)}
        //   PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
          Do you want to delete this Security?
        </DialogTitle>
        {/* <DialogContent>
         
        </DialogContent> */}
        <DialogActions>
          <Button onClick={() => setdeleteDialogBox(false)} variant="outlined">
            No
          </Button>
          <Button
            autoFocus
            onClick={(e) => deleteRequest(e)}
            variant="contained"
            color="primary"
            // disabled={disableeditAmountUpdateBtn}
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default TableAddReviewReq;
